import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { ApiService } from '@app/services/api.service';
import { firstValueFrom } from 'rxjs';

export interface PrerolloutResponse {
  readonly prerollout: boolean;
}

/**
 * Service for checking prerollout availability based on postal code and product.
 * Uses the REST endpoint /api/mobi/prerollout/{nid}/{zip}
 */
@Service()
export class PrerolloutService {
  #http = inject(HttpClient);
  #api = inject(ApiService);

  /**
   * Check prerollout availability for a given product and postal code.
   * @param nid - The product node ID
   * @param zip - The postal code (4 digits) + optional 2-digit addition (6 digits total)
   * @returns Whether the postal code is mapped to this product for prerollout
   */
  async checkPrerollout(nid: string, zip: string): Promise<boolean> {
    try {
      const url = `${this.#api.apiUrl}/api/mobi/prerollout/${nid}/${zip}?_format=json`;
      const response = await firstValueFrom(this.#http.get<PrerolloutResponse>(url));
      return response?.prerollout ?? false;
    } catch {
      return false;
    }
  }
}
